import React from 'react'
import ContactUsContent from '../../../components/contact-us/contact-us'
import AuthLayout from '../auth-layout'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AUTH_KEYS, LANDING_KEYS } from '../../../utils/translation-constants'
export default function Landing_ContactUs() {
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <div style={{width:350,margin:'0 auto'}}>
        <h3 style={{textAlign:'center',marginTop:10}}>{t(LANDING_KEYS.CONTACT_US)}</h3>
        <ContactUsContent />
        
        <div className='row text-center d-flex justify-content-center '>
          <button
            onClick={() =>
              history.push({
                pathname: '/landing',
              })
            }
            className='btn btn-sm btn-link small new-design-warning-text-color font-weight-600'>
            {t(AUTH_KEYS.FORGOT_PASSWORD_KEYS.RESET_KEYS.BACK)}
          </button>
        </div>
        <div className='my-4' />
      </div>
    </AuthLayout>
  )
}
